export enum AssetIdentifierType {
  MaskedUid = 'masked_uid',
  Serial = 'serial',
}

export const FriendlyAssetIdentifierType: Record<AssetIdentifierType, string> = {
  [AssetIdentifierType.MaskedUid]: 'Masked ID (Payload)',
  [AssetIdentifierType.Serial]: 'Serial',
}
